import { toast } from 'react-toastify';

import { QueryCache, QueryClientConfig } from '@tanstack/react-query';

export const queryHeaders = (method = 'POST', authToken?: string) => {
  const AuthHeader = authToken ? { Authorization: `Bearer ${authToken}` } : {};
  const requestInit = {
    headers: {
      method,
      'Content-Type': 'application/json',
      ...AuthHeader,
    },
  };
  return requestInit;
};

const queryCache = new QueryCache({
  onError: (error, query) => {
    const suppressErrorByKey = ['alleDefecten', 'alleSignalen', 'alleConflicten', 'verversStamgegevens'].includes(
      String(query.queryKey?.[0]),
    );
    const suppressErrorByMeta =
      typeof query.meta === 'object' &&
      query.meta !== null &&
      'suppressGlobalErrorToast' in query.meta &&
      query.meta.suppressGlobalErrorToast === true;
    const suppressError = suppressErrorByKey || suppressErrorByMeta;
    if (!suppressError) {
      if (error instanceof Error) {
        toast.error('BAM kan geen verbinding met de server maken');
      } else {
        console.error('Onbekende fout', error);
        toast.error('Onbekende fout opgetreden');
      }
    }
  },
});

export const queryConfig: () => QueryClientConfig = () => {
  return {
    queryCache,
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 0,
        structuralSharing: false,
        staleTime: 10000,
        gcTime: 30000,
      },
      mutations: {
        retry: 0,
      },
    },
  };
};

export const headerJson = () => ({ 'Content-Type': 'application/json' });
export const headerAuthorization = (accessToken?: string) => ({
  Authorization: `Bearer ${accessToken}`,
});
export const headerBuildNumber = (buildNr: number | string = '') => ({
  'X-Client-Image-Build-Number': `${buildNr}`,
});

export const getRequestInit = (init?: Partial<RequestInit>): RequestInit => ({
  method: 'GET',
  headers: {
    ...headerJson(),
    ...(init?.headers ? init.headers : {}),
  },
  ...(init || {}),
});

export const postRequestInit = <T>(data: T, init?: Partial<RequestInit>): RequestInit => ({
  method: 'POST',
  body: JSON.stringify(data),
  headers: {
    ...headerJson(),
    ...(init?.headers ? init.headers : {}),
  },
  ...(init || {}),
});
